export const faqItems = [
  {
    question: 'A plataforma serve para minha especialidade específica?',
    answer:
      'Sim! Nosso sistema cruza a base jurídica da Doctor Legal com a sua rotina. Dispomos de documentos, termos de consentimento e diretrizes focadas nas especialidades mais comuns do Brasil.',
  },
  {
    question: 'E se eu já for processado, a Doctor Legal me defende no tribunal?',
    answer:
      'A Doctor Legal é uma plataforma de compliance e consultoria jurídica de performance profissional. Para o plano Especialista, ajudamos a analisar documentos críticos e preparar sua base antes do conflito. Acompanhamento processual ativo (comparecer em juízo) é um serviço jurídico presencial que deve ser contratado nos moldes da legislação vigente.',
  },
  {
    question: 'Como funciona a consultoria por videochamada?',
    answer:
      'No plano Especialista, você tem direito a uma consultoria 1:1 mensal com nossos especialistas. O agendamento ocorre diretamente no painel. É um momento exclusivo e sigiloso para tratar os desafios diários da sua clínica ou hospital.',
  },
  {
    question: 'Os termos de consentimento são atualizados?',
    answer:
      'Constantemente. Nossa equipe jurídica acompanha a evolução da legislação civil e das resoluções do CFM. Assim que identificamos novos riscos em procedimentos, atualizamos os documentos instantaneamente.',
  },
]
